<script>
import {  common } from '@/mixins/common'

export default {
  name: 'DisplayLabelPreviewDialog',
  components: {},
  props: {
    displayDialog: {
      type: Boolean,
      required: true
    },
    invoiceUrl: {
      type: String,
      required: true,
      default() {
        return ""
      }
    }
  },
  data() {
    return {}
  },
  mixins: [
    common
  ],
  methods: {
    openInTab() {
      window.open(this.invoiceUrl, "_blank")
    },
    handleDialogClose() {
      this.$root.$emit('close-dialog', 'displayInvoicePreviewDialog')
    }
  },
  watch: {}
}
</script>

<template>
    <el-dialog
      custom-class="el-dialog-bs-info el-dialog-label-preview"
      :visible.sync="displayDialog"
      width="80%"
      @close="handleDialogClose">
      <span slot="title"><h5><i class="fas fa-file-invoice"></i> INVOICE PREVIEW</h5></span>
        <div class="">
          <embed
            :src="invoiceUrl"
            type="application/pdf"
            title="Invoice PDF"
            width="100%"
            height="520px"
            style="overflow: auto;"/>
        </div>
      <span slot="footer" class="dialog-footer text-center pb-0">
        <el-button
          @click="openInTab()"
          type="danger"
          class="mb-1">MAXIMIZE</el-button>
      </span>
    </el-dialog>
</template>

<style>

</style>
